import {
    FETCH_ACTIVITIES_BEGIN, FETCH_ACTIVITIES_SUCCESS, FETCH_ACTIVITIES_FAILURE, FETCH_CATEGORY_BEGIN, FETCH_CATEGORY_SUCCESS, FETCH_CATEGORY_FAILURE, FETCH_ACTIVITYTYPE_BEGIN,
    FETCH_ACTIVITYTYPE_SUCCESS,
    FETCH_ACTIVITYTYPE_FAILURE, FETCH_ACTIVITYENTITYTYPE_BEGIN,
    FETCH_ACTIVITYENTITYTYPE_SUCCESS,
    FETCH_ACTIVITYENTITYTYPE_FAILURE,
    FETCH_ACTIVITYENTITY_BEGIN,
    FETCH_ACTIVITYENTITY_FAILURE,
    FETCH_ACTIVITYENTITY_SUCCESS,
    FETCH_ACTIVITYDETAILS_BEGIN,
    FETCH_ACTIVITYDETAILS_FAILURE,
    FETCH_ACTIVITYDETAILS_SUCCESS,
    FETCH_ACCOUNTORCONTACT_BEGIN,
    FETCH_ACCOUNTORCONTACT_FAILURE,
    FETCH_ACCOUNTORCONTACT_SUCCESS
} from '../constants/investment';

const initialState={
    activitityDetails: [],
    activityDetail: [],
    Category: [],
    ActivityType: [],
    ActivityentityType:[],
    Activityentity:[],
    ActivityentityLoading:false,
    activityEntities:[],
    isLoading:false,
    error:"",
}


export const getActivitiesDetailsReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ACTIVITIES_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ACTIVITIES_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            activitityDetails:null
        };
    case FETCH_ACTIVITIES_SUCCESS:
        return {
            ...initialState,
            activitityDetails:payload.activitityDetails,
            isLoading:false,
        };
       
    default:
        return state;
 }
}

export const getCategoryReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_CATEGORY_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_CATEGORY_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                Category: null
            };
        case FETCH_CATEGORY_SUCCESS:
            return {
                ...initialState,
                Category: payload.Category,
                isLoading: true,
            };
        default:
            return state;
    }
}

export const getActivityTypeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ACTIVITYTYPE_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ACTIVITYTYPE_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                ActivityType: null
            };
        case FETCH_ACTIVITYTYPE_SUCCESS:
            return {
                ...initialState,
                ActivityType: payload.ActivityType,
                isLoading: true,
            };
        default:
            return state;
    }


}

export const getActivityEntityTypeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ACTIVITYENTITYTYPE_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ACTIVITYENTITYTYPE_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                ActivityentityType: null
            };
        case FETCH_ACTIVITYENTITYTYPE_SUCCESS:
            return {
                ...initialState,
                ActivityentityType: payload.ActivityentityType,
                isLoading: true,
            };
        default:
            return state;
    }
}
export const getActivityEntityReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ACTIVITYENTITY_BEGIN: {
            return {
                ...state,
                ActivityentityLoading: true,
                error: null,
            };
        }
        case FETCH_ACTIVITYENTITY_FAILURE:
            return {
                ...initialState,
                ActivityentityLoading: false,
                Activityentity: null
            };
        case FETCH_ACTIVITYENTITY_SUCCESS:
            return {
                ...initialState,
                Activityentity: payload.Activityentity,
                ActivityentityLoading: true,
            };
        default:
            return state;
    }


}
export const getActivityDetailReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ACTIVITYDETAILS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ACTIVITYDETAILS_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                activityDetail: null
            };
        case FETCH_ACTIVITYDETAILS_SUCCESS:
            return {
                ...initialState,
                activityDetail: payload.activityDetail,
                isLoading: false,
            };
        default:
            return state;
    }
}
     //AccountOrContact
     export const getAccountorContactReducer = (state = initialState, action) => {
        const { type, payload } = action;
        switch (type) {
     case  FETCH_ACCOUNTORCONTACT_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case  FETCH_ACCOUNTORCONTACT_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            activityEntities:null
        };
    case FETCH_ACCOUNTORCONTACT_SUCCESS:
      
        return {
            ...initialState,
            activityEntities:payload.activityEntities,
            isLoading:false,
        };
        default:
            return state;
}
     }